module["exports"] = [
  "Qasımova",
  "Əfəndiyeva",
  "Soltanova",
  "Abdullayeva",
  "Rəşidova",
  "Ələkbərova",
  "Əliyeva",
  "Tahirova",
  "Seyidova",
  "Vəsiyeva"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/az/name/female_last_name.js
// module id = 2353
// module chunks = 1610